import { Box, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

const ProductTitle = styled(Typography).attrs({
  as: "h1",
  fontSize: { _: "26px", tablet: "24px" },
  fontWeight: { _: "300", tablet: "300" },
  mr: { _: 0, desktop: 5 },
  mt: { _: 0, tablet: "-4px" },
  pb: { _: "7px", tablet: 0 },
  pt: { _: "5px", tablet: 0 },
  textAlign: { _: "center", tablet: "left" },
})``

const InternalTitle = ({ title }) => {
  return (
    <Box flex="1 0 auto">
      <ProductTitle>{title}</ProductTitle>
    </Box>
  )
}

const mapStateToProps = (state, ownProps) => {
  let title = state.wizard.title
  if (state.wizard.loading) {
    if (ownProps.data.wizard_header) {
      title = ownProps.data.wizard_header.title
    } else {
      title = ""
    }
  }
  return {
    hideMiniview: state.previewImageUI.miniview.scrollHide,
    openedDescriptionPanels: state.panel.openedInfoPanelIndexes,
    title,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalTitle.propTypes = {
  hideMiniview: PropTypes.bool,
  title: PropTypes.string,
}

const Title = connect(mapStateToProps, mapDispatchToProps)(InternalTitle)

export default Title
